import { Event } from '@ssp/inscreva-sse-models';
import axios from 'axios';
import { Module, MutationAction, VuexModule } from 'vuex-module-decorators';

import config from '../utils/config';
import { _serializer } from '../utils/serializer';

@Module({
  name: 'eventsStore',
})
export default class EventsStore extends VuexModule {
  _events: Array<Event> = undefined;

  @MutationAction({ mutate: ['_events'] })
  async fetch(): Promise<{ _events: Array<Event> }> {
    return {
      _events: (
        await axios.get(`${config.getAPIAddress()}/event`, {
          params: {
            limit: 20,
            'info.active': {
              $ne: false,
            },
          },
          paramsSerializer: _serializer,
        })
      ).data as Array<Event>,
    };
  }

  get events(): Array<Event> {
    return this._events;
  }
}
